/**
 * base on application/models/CandidateOneTimePopup.php
 */
export const POPUP_NOTIFICATION_TYPE = {
  HOME_INTERVIEW_DATA: 'interview-data',
  HOME_REVIEW: 'review',
  HOME_GAT: 'gat',
  HOME_RECOMMENDATION: 'recommendation',
  HOME_RESUME_OLD: 'resume-old',

  NETWORK_SCHOOL_ALUMNI: 'network-school-alumni',
};
